import { useEffect, useState } from 'react';

import { getSetting, settingKeys } from '../utils/settings';

// What the page reads at before anyone has touched the control — FontSizePlugin's own first step
export const DEFAULT_FONT_SIZE = '16px';

/**
 * The size the reader has set the words to, from the Font Size plugin.
 *
 * Stored as a setting and announced on a `fontSizeChanged` window event, because the control is a
 * plugin in the View chrome and the words it sizes are rendered somewhere else entirely. Anything
 * showing a part's lyrics reads it the same way, so the size holds wherever those words turn up —
 * the page, and the player's Lyrics view over the top of it.
 */
const useFontSize = () => {
  const [fontSize, setFontSize] = useState(() => getSetting(settingKeys.fontSize) || DEFAULT_FONT_SIZE);

  useEffect(() => {
    const handleChange = (event) => setFontSize(event.detail.fontSize);

    window.addEventListener('fontSizeChanged', handleChange);

    return () => window.removeEventListener('fontSizeChanged', handleChange);
  }, []);

  return fontSize;
};

export default useFontSize;
